import React from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Addpost.css";

function AddPost() {
  return (
    <div data-toggle="modal" data-target="#addPostModal">
      <button type="button" className="btn btn-warning rounded-circle">
        <FontAwesomeIcon icon={faPlus} />
      </button>
    </div>
  );
}

export default AddPost;
